import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getBlogCategory = async (id) => {
  try {
    return await getData(`/without-login/blog/category`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllBlog = async ({ id, search, page, per_page, }) => {
  try {
    return await getData(`/without-login/blog?search=${search || ""}&id=${id || ""}&page=${page || ""}&per_page=${per_page || 10}`);
  } catch (error) {
    console.log(error);
  }
};

export const getSingleBlog = async (id) => {
  try {
    return await getData(`/without-login/blog/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const BlogCommentPost = async (data) => {
  try {
    const res = await postData(`/without-login/blog/comment`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};


